import type { DatabasePickerEntry, UserDatabasesResponse } from '@/userManagement/application/types';

import { dedupeTenantDatabaseEntries, parseTenantDatabaseEntry } from './parseTenantDatabaseEntry';

function normalizeDatabaseEntries(value: unknown): DatabasePickerEntry[] {
  if (!Array.isArray(value)) return [];
  return dedupeTenantDatabaseEntries(value.map(parseTenantDatabaseEntry).filter((e): e is NonNullable<typeof e> => e != null)).map((e) => ({
    name: e.tenantDatabaseName,
    alias: e.databaseAlias ?? null
  }));
}

/** Accepts `{ assignedDatabases, availableDatabases }` or a legacy `string[]` (treated as assigned only). */
export function parseUserDatabasesResponse(data: unknown): UserDatabasesResponse {
  if (Array.isArray(data)) {
    const assignedEntries = normalizeDatabaseEntries(data);
    return {
      assignedDatabases: assignedEntries.map((e) => e.name),
      availableDatabases: [],
      assignedEntries,
      availableEntries: []
    };
  }
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    const assignedRaw = o.assignedDatabases ?? o.assigned_databases ?? o.databases ?? o.databaseNames;
    const availableRaw = o.availableDatabases ?? o.available_databases ?? o.unassignedDatabases;
    const assignedEntries = normalizeDatabaseEntries(assignedRaw);
    const availableEntries = normalizeDatabaseEntries(availableRaw);
    return {
      assignedDatabases: assignedEntries.map((e) => e.name),
      availableDatabases: availableEntries.map((e) => e.name),
      assignedEntries,
      availableEntries
    };
  }
  return { assignedDatabases: [], availableDatabases: [], assignedEntries: [], availableEntries: [] };
}

/** Reads tenantDatabaseName from object rows (legacy helper for tests). */
export function databaseNameFromEntry(entry: unknown): string | null {
  const parsed = parseTenantDatabaseEntry(entry);
  return parsed?.tenantDatabaseName ?? null;
}
